// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementLandingPagesAppGroupIdSizeLimitsResult = objectOf({
  settings: objectOf({
    size_limit: number,
  }),
  warned_pages: arrayOf(
    objectOf({
      id: string,
      name: string,
    })
  ),
});
